// Single source of truth for product naming + date display (DD-MM-YYYY everywhere).
export const PRODUCT_NAME = "Trifit.XPS";
export const BRAND_PINK = "#D2378B";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function toDate(v) {
  if (!v) return null;
  if (v instanceof Date) return isNaN(v) ? null : v;
  const s = String(v);
  const iso = s.length >= 10 ? s.slice(0, 10) : s;
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  const d = new Date(s);
  return isNaN(d) ? null : d;
}

const pad = (n) => String(n).padStart(2, "0");

/** DD-MM-YYYY (product standard). Accepts ISO strings, Date objects, ISO datetimes. */
export function fmtDate(v, fallback = "—") {
  const d = toDate(v);
  if (!d) return fallback;
  return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()}`;
}

/** DD-MM-YYYY HH:MM */
export function fmtDateTime(v, fallback = "—") {
  const d = toDate(v);
  if (!d) return fallback;
  const t = String(v).includes("T") ? new Date(v) : d;
  return `${fmtDate(v)} ${pad(t.getHours())}:${pad(t.getMinutes())}`;
}

/** Short "DD Mon" for dense tables / chart axes. */
export function fmtDayShort(v, fallback = "—") {
  const d = toDate(v);
  if (!d) return fallback;
  return `${pad(d.getDate())} ${MONTHS[d.getMonth()]}`;
}

export function fmtINR(n) {
  const v = Number(n || 0);
  return `₹${v.toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
}
